import { Component, ContentChild, Input, TemplateRef } from '@angular/core';

@Component({
  selector: 'app-empty-state',
  templateUrl: './empty-state.component.html',
  styleUrls: ['./empty-state.component.scss']
})
export class EmptyStateComponent {
  @Input() title: string = 'No data found';
  @Input() message: string = 'There is no data matching your current filters. Try adjusting your filters.';
  
  @ContentChild('emptyStateIcon') customIcon: TemplateRef<any>;
  @ContentChild('emptyStateActions') actionsTemplate: TemplateRef<any>;
}
